import React from "react";

export default function Denied() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F6F3EC] text-[#1B1B1B] px-6">
            <div className="max-w-md">
                <p className="eyebrow text-[#1B1B1B]/60 mb-4">§ Access — 403</p>
                <h1 className="font-serif-editorial text-4xl md:text-5xl leading-[1.02] mb-6">
                    This account isn't the studio's.
                </h1>
                <p className="font-sans-tight text-base leading-[1.6] text-[#1B1B1B]/75 mb-8 font-light">
                    The admin area is restricted to a single Google account.
                    If this is your studio, please sign in with the correct
                    account.
                </p>
                <a href="/admin/login" className="eyebrow link-underline">
                    ← Try again
                </a>
            </div>
        </div>
    );
}
